import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'reactstrap';
import { useIntl } from 'react-intl';

import { showModalTop } from '../../actions';

const AccessModalAddNew = ({
  dispatch,
  handleAddNewGroup,
  handleAddNewUser,
}) => {
  const intl = useIntl();

  const handleOpenAddGroupModal = () => {
    dispatch(showModalTop('GroupEditModal', {
      className: 'modal-edit-group',
      notificationCallback: handleAddNewGroup,
    }));
  };

  const handleOpenAddUserModal = () => {
    dispatch(showModalTop('UserEditModal', {
      className: 'modal-edit-user',
      notificationCallback: handleAddNewUser,
    }));
  };

  return (
    <UncontrolledDropdown>
      <DropdownToggle className="btn btn-primary">
        <i className="fas fa-plus" />
      </DropdownToggle>
      <DropdownMenu right>
        <DropdownItem
          onClick={(e) => {
            e.preventDefault();
            handleOpenAddUserModal();
          }}
        >
          {intl.formatMessage({ defaultMessage: 'Invite new user' })}
        </DropdownItem>
        <DropdownItem
          onClick={(e) => {
            e.preventDefault();
            handleOpenAddGroupModal();
          }}
        >
          {intl.formatMessage({ defaultMessage: 'Create new Team' })}
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

AccessModalAddNew.propTypes = {
  dispatch: PropTypes.func.isRequired,
  handleAddNewGroup: PropTypes.func.isRequired,
  handleAddNewUser: PropTypes.func.isRequired,
};

export default connect()(AccessModalAddNew);
